"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var locale_1 = require("../locale");
/**
 * Takes in two times and returns the time range.
 *
 * This should _only_ be used for polyfill when formatRange
 * is not available on old browser versions. Do _not_ use as
 * the default way of getting a time range,
 * use formatTimeRange() instead.
 *
 * @param locale, formattedStart, formattedEnd (all strings)
 */
var getPolyfillDateRange = function (locale, formattedStart, formattedEnd) {
    switch (locale) {
        case locale_1.Locale.DE_DE:
            return formattedStart + "\u2013" + formattedEnd + " Uhr";
        default:
            return formattedStart + " \u2013 " + formattedEnd;
    }
};
exports.default = getPolyfillDateRange;
